// extracted by mini-css-extract-plugin
module.exports = {"base":"_1PB2ofm8RSB5psM_VAChNK","active":"_1yUpp5pF9zPxu6Of0AbssT"};